// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderSendPaymentLink_container__32BF9","text":"OrderSendPaymentLink_text__1sssv","text-ltr":"OrderSendPaymentLink_text-ltr__2r8aD"};